import { sortBy } from "./sortBy";

/**
 * [Mutator] Sort children of item and recurse for grandchildren.
 * @param obj
 * @param childKey
 * @param sortKey
 */
export function sortAll(obj: any, childKey: string, sortKey: string) {
    if (!obj[childKey] || !(obj[childKey] instanceof Array)) return;
    obj[childKey].sort(sortBy([sortKey]));
    obj[childKey].forEach(child => sortAll(child, childKey, sortKey));
}
